<template>
    <div>
        <template v-if="isLoading">
            <div class="row">
                <div class="col-md-12 d-flex">
                    <div class="skeleton-progress progress mr-2" style="width: 25%; height: 4em;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                    </div>
                    <div class="skeleton-progress progress mr-2" style="width: 25%; height: 4em;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                    </div>
                    <div class="skeleton-progress progress mr-2" style="width: 25%; height: 4em;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                    </div>
                    <div class="skeleton-progress progress" style="width: 25%; height: 4em;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="skeleton-progress progress" style="height: 30em;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <tabs class="ses-tabs" :fill="0" :pills="0" :activeTab="0">
                <card shadow>
                    <template v-for="(guide, key) in guides">
                        <tab-pane :key="key" :title="guide.title" :id="key">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th style="width: 30%;">Symptom</th>
                                            <th style="width: 35%;">Possible Causes</th>
                                            <th style="width: 35%;">Solution</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(symptom, key) in guide.symptoms">
                                            <tr :key="key">
                                                <td :rowspan="get_rowspan(symptom)">{{ symptom.title }}</td>
                                                <td :rowspan="symptom.possible_causes[0].solutions.length">{{ symptom.possible_causes[0].title }}</td>
                                                <td>{{ symptom.possible_causes[0].solutions[0] }}</td>
                                            </tr>
                                            <template v-for="(possible_cause, key) in symptom.possible_causes">
                                                <template v-if="key > 0">
                                                    <tr :key="key">
                                                        <td :rowspan="possible_cause.solutions.length">{{ possible_cause.title }}</td>
                                                        <td>{{ possible_cause.solutions[0] }}</td>
                                                    </tr>
                                                </template>
                                                <template v-for="(solution, key) in possible_cause.solutions">
                                                    <template v-if="key > 0">
                                                        <tr :key="key">
                                                            <td>{{ solution }}</td>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </tab-pane>
                    </template>
                </card>
            </tabs>
        </template>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isLoading: false,
            guides: []
        }
    },
    mounted() {
        this.get_guides()
    },
    methods: {
        get_guides() {
            this.isLoading = true
            this.$http.get('/api/troubleshooting_guides')
                .then(response => {
                    this.guides = response.data.data
                    this.isLoading = false
                })
        },
        get_rowspan(symptom) {
            let rowspan = 0

            for(let x = 0; x < symptom.possible_causes.length; x++) {
                if(symptom.possible_causes[x]) {
                    rowspan += symptom.possible_causes[x].solutions.length
                }
            }

            return rowspan
        }
    }
}
</script>
<style lang="scss" scoped>
.ses-tabs::v-deep {
    .table {
        td {
            text-align: center;
            vertical-align: middle;
        }
    }
}  
</style>